// The company's construction vocabularies (back/routes/taxonomy.js):
// project stages, activity categories, milestone kinds and the WBS
// backbone. Trades come from /discipline, design phases from /milestones.
import { url, tokenRef } from "api";

const headers = () => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${localStorage.getItem(tokenRef)}`,
});

const EMPTY = { project_stage: [], activity_category: [], milestone_kind: [], wbs_node: [] };

// Every list in one request - a page needing three pickers should not
// make three round trips. Never throws: a picker with no options is a
// worse day than a page that fails to load.
export async function getTaxonomy() {
  try {
    const res = await fetch(`${url}/taxonomy`, { headers: headers() });
    if (!res.ok) return { ...EMPTY };
    const body = await res.json();
    return { ...EMPTY, ...(body || {}) };
  } catch (e) {
    return { ...EMPTY };
  }
}

export async function addTaxonomyItem(kind, body) {
  const res = await fetch(`${url}/taxonomy/${kind}`, {
    method: "POST", headers: headers(), body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.err || "Could not add that");
  return data;
}

export async function updateTaxonomyItem(kind, id, body) {
  const res = await fetch(`${url}/taxonomy/${kind}/${id}`, {
    method: "PUT", headers: headers(), body: JSON.stringify(body),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.err || "Could not save that");
  return data;
}

export async function removeTaxonomyItem(kind, id) {
  const res = await fetch(`${url}/taxonomy/${kind}/${id}`, { method: "DELETE", headers: headers() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.err || "Could not remove that");
  return data;
}

// Top up whatever the company is missing (a company that registered
// before the defaults existed).
export async function seedTaxonomy() {
  const res = await fetch(`${url}/taxonomy/seed`, { method: "POST", headers: headers() });
  const data = await res.json();
  if (!res.ok) throw new Error(data.err || "Could not seed the company lists");
  return data;
}

// [{value,label}] for an antd Select, in the company's own order.
export const asOptions = (rows) =>
  (rows || []).map((r) => ({ value: r.key, label: r.label, title: r.description || r.label }));
